<template>
    <div class="downloadExcel">
        <i class="iconfont icon-exclefile color-grey fs20 cp" title="下载表格" @click="downExcel()"></i>
    </div>
</template>

<script>
const ExportJsonExcel = require('js-export-excel');
export default {
    name:"downloadExcel",
    props:{
        dataExcle:{
            type:[Object,Array]
        },
        type:{
            type:[String]
        },
        excleName:{
            type: String,
            default:''
        },
        lineExcleType:{
            type: String,
            default:'oneArr'
        },
        dataType:{
            type: String,
            default:''
        },
    },
    data() {
        return {

        }
    },
    watch:{
        dataExcle:{
            handler(n,o){
                
            }
        }
    },
    methods:{
        downExcel(){
            //console.log('表格数据',this.dataExcle)
            // return;
            let option={};
            option.fileName = this.excleName; //文件名;
            let allsheetData=[];
            let exleObj={}; 
            let sheetData = {};
            if(this.type === 'line'){
                //更具类别拆分表格
                for(let i of this.dataExcle.dataName){
                    sheetData={
                        //第一个sheet（第一个excel表格）
                        sheetData:[],//数据
                        sheetName:i,
                        sheetFilter:['name','value'],   //表头数据对应的sheetData数据
                        sheetHeader:['时间','数量'], //表头数据
                        columnWidths: ['10','10'], // 列宽
                    };
                    if(this.dataType === 'lineData'){
                        if(this.lineExcleType === 'threeArr'){
                            let j = 0;
                            for(let k=0;k<this.dataExcle.datetime.length;k++){
                                exleObj = {name:this.dataExcle.datetime[k],value:this.dataExcle.data[i][j][k]}
                                sheetData.sheetData.push(exleObj); 
                            }
                            j++;
                        }else{
                            for(let k=0;k<this.dataExcle.datetime.length;k++){
                                exleObj = {name:this.dataExcle.datetime[k],value:this.dataExcle.data[i][k]}
                                sheetData.sheetData.push(exleObj); 
                            }
                        }
                    }else{
                        for(let k=0;k<this.dataExcle.datetime.length;k++){
                            exleObj = {name:this.dataExcle.datetime[k],value:this.dataExcle[i][k]}
                            sheetData.sheetData.push(exleObj); 
                        }
                    }
                    allsheetData.push(sheetData);
                }
            }else if(this.type === 'pie'){
                sheetData={
                    //第一个sheet（第一个excel表格）
                    sheetData:this.dataExcle,//数据
                    sheetName:this.excleName,
                    sheetFilter:['name','value'],   //表头数据对应的sheetData数据
                    sheetHeader:['类别','数量'], //表头数据
                    columnWidths: ['10','10'], // 列宽
                };
                allsheetData.push(sheetData);
            }else if(this.type === 'bar'){
                sheetData={
                    //第一个sheet（第一个excel表格）
                    sheetData:[],//数据
                    sheetName:this.excleName,
                    sheetFilter:['name','value'],   //表头数据对应的sheetData数据
                    sheetHeader:['类别','数量'], //表头数据
                    columnWidths: ['10','10'], // 列宽
                };
                for(let k=0;k<this.dataExcle.datetime.length;k++){
                    exleObj = {name:this.dataExcle.datetime[k],value:this.dataExcle.data[0][k]}
                    sheetData.sheetData.push(exleObj); 
                }
                allsheetData.push(sheetData);
            }
            option.datas=allsheetData;
            let toExcel=new ExportJsonExcel(option);
            toExcel.saveExcel();
        }
    }
}
</script>
<style scoped>
    .downloadExcel{
        position: absolute;
        right: -15px;
        top:0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/downloadExcel.vue